// extracted by mini-css-extract-plugin
export default {"warningsModalCloseButton":"WarningsPopup_warningsModalCloseButton__owMiG"};